import React from 'react'
import { SanityInvestmentStrategies } from '../../../../../types/generated/graphql-types'
import { useTranslations } from '../../../../hooks/useTranslations'
import { mapSanityInvestmentStrategiesToInvestmentStrategiesProps } from '../../../../mapping/InvestmentStrategiesMapper'
import { BlockWithId } from '../../../../utilities/blockId'
import { InvestmentStrategies } from '../../../blocks/InvestmentStrategies'
import { MarketSection } from '../../../MarketSection'

export type InvestmentStrategiesSerializerProps = SanityInvestmentStrategies & BlockWithId

export const InvestmentStrategiesSerializer = ({
  id,
  ...props
}: InvestmentStrategiesSerializerProps) => {
  const translations = useTranslations()

  return (
    <MarketSection applyGrid={false} id={id}>
      <InvestmentStrategies
        {...mapSanityInvestmentStrategiesToInvestmentStrategiesProps(props, translations)}
      />
    </MarketSection>
  )
}
